import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { Card, Button, Alert } from 'react-bootstrap';

const TurnoCajaInfo = () => {
  const [turno, setTurno] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTurno = async () => {
    try {
      const res = await api.get('/turnos-caja/activo');
      setTurno(res.data);
    } catch (err) {
      console.error('Error al obtener turno:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTurno();
  }, []);

  if (loading) return <p>Cargando turno...</p>;

  if (!turno) {
    return (
      <Alert variant="warning">
        No hay un turno de caja abierto actualmente. Iniciá uno para comenzar.
        <div className="mt-2">
          <Button onClick={async () => {
            await api.post('/turnos-caja/abrir');
            fetchTurno();
          }}>🟢 Abrir turno</Button>
        </div>
      </Alert>
    );
  }

  return (
    <Card className="mb-4">
      <Card.Body>
        <Card.Title>🧾 Turno de caja activo</Card.Title>
        <p><strong>Apertura:</strong> {new Date(turno.fecha_apertura).toLocaleString()}</p>
        <p><strong>ID:</strong> {turno.id}</p>
        <Button
          variant="danger"
          onClick={async () => {
            await api.put(`/turnos-caja/${turno.id}/cerrar`, {
              observaciones: prompt('¿Deseás dejar una observación del cierre?') || ''
            });
            fetchTurno(); // actualiza para mostrar que se cerró
          }}
        >
          🔴 Cerrar turno
        </Button>
      </Card.Body>
    </Card>
  );
};

export default TurnoCajaInfo;
